<script setup lang="ts">
import { emitter, Heart, useLikesStore } from "@innoclouds/shared";
import { useTimeoutFn } from "@vueuse/core";
import { useTranslation } from "i18next-vue";
import { onUnmounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";

const AUTO_HIDE_MS = 5000;

const router = useRouter();
const route = useRoute();
const likesStore = useLikesStore();
const { t } = useTranslation();

const visible = ref(false);
const productId = ref<string | null>(null);
const liked = ref(false);

const { start: startHideTimer } = useTimeoutFn(
	() => {
		visible.value = false;
	},
	AUTO_HIDE_MS,
	{ immediate: false },
);

const showToast = (payload: { productId: string; liked: boolean }) => {
	if(route?.query?.mode === "pdf") return;
	productId.value = payload.productId;
	liked.value = payload.liked;
	visible.value = true;
	startHideTimer();
};

const openFavorites = () => {
	visible.value = false;
	router.push({ name: "home", params: { orgId: route.params.orgId }, query: { ...route.query, favorites: "1" } });
};

const undo = () => {
	if (!productId.value) return;
	visible.value = false;
	likesStore.toggleLike(productId.value);
};

emitter.on("like-toggled", showToast);
onUnmounted(() => emitter.off("like-toggled", showToast));
</script>

<template>
	<Transition name="like_toast_fade">
		<div v-if="visible" class="like_toast">
			<Heart :filled="liked" />
			<p>{{ liked ? t("likes.toast.added") : t("likes.toast.removed") }}</p>
			<button type="button" @click="liked ? openFavorites() : undo()">{{ liked ? t("likes.toast.open") : t("likes.toast.restore") }}</button>
		</div>
	</Transition>
</template>

<style lang="scss">
@use "./likeToast.scss";
</style>
